// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kM1SJOqeh4MXuob_ {
  background-color: #ffffff;
  margin-top: 20px;
  border-radius: 10px;
  padding: 20px;
  position: relative;
}

.kM1SJOqeh4MXuob_ {
  padding: 2rem;
}

.tI683XD5eU2_zB_y {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.tI683XD5eU2_zB_y h2 {
  margin: 0;
}

.UdDt6tPpPeQNRd_e {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}

.XOe5jkh9DREcTcSC {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.UdDt6tPpPeQNRd_e canvas {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.tI683XD5eU2_zB_y .p-button-success > .p-button-icon {
  margin-right: 10px;
}

.RnwhTbK95eUYJON8 {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: #9b9b9bb6;
  backdrop-filter: blur(5px);
}

.geYVLR2f40CujOjm {
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  height: 100px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.vgwnlQdzkB8kCRaq {
  background-color: #0078ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/GeneratedPDF/GeneratedPDF.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wrapper {\r\n  background-color: #ffffff;\r\n  margin-top: 20px;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  position: relative;\r\n}\r\n\r\n.wrapper {\r\n  padding: 2rem;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n}\r\n\r\n.pdfContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n}\r\n\r\n.controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.pdfContainer canvas {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  border-radius: 4px;\r\n}\r\n\r\n.header :global(.p-button-success > .p-button-icon) {\r\n  margin-right: 10px;\r\n}\r\n\r\n.modalWrapper {\r\n  position: fixed;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  left: 0;\r\n  top: 0;\r\n  z-index: 10;\r\n  background-color: #9b9b9bb6;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.modal {\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  width: 400px;\r\n  height: 100px;\r\n  background-color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.paginationBtn {\r\n  background-color: #0078ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `kM1SJOqeh4MXuob_`;
export var header = `tI683XD5eU2_zB_y`;
export var pdfContainer = `UdDt6tPpPeQNRd_e`;
export var controls = `XOe5jkh9DREcTcSC`;
export var modalWrapper = `RnwhTbK95eUYJON8`;
export var modal = `geYVLR2f40CujOjm`;
export var paginationBtn = `vgwnlQdzkB8kCRaq`;
export default ___CSS_LOADER_EXPORT___;
